module.exports = __webpack_public_path__ + "static/pers-afed2862ebd1145eff5cd82006c02084.png";